import type { CommonOptions } from "bm-ui-kit";

export const HAS_EITHER_OF_COUPLE_SOCIAL_INSURANCE: CommonOptions = [
	{ label: "Igen, több mint 3 éve", value: "THREE_AND_MORE" },
	{ label: "Igen, kevesebb mint 3 éve", value: "LESS_THAN_THREE" },
	{ label: "Nincs ", value: "NONE" },
];
